import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { TaxDto } from './tax-dto';

export class TaxesResponseModel extends GlobalResponseObject{
    data?: TaxDto;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: TaxDto){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}
